import sliceCreator from '../../index.js';
import {GET_MACHINE} from '../../../constants/index.js';
const _getMachineByIdAction = sliceCreator('GET_MACHINE', GET_MACHINE, 'get');

const { asyncAction: getMachineByIdAction, reducer, clearData: clearGetMachineByIdAction } = _getMachineByIdAction;

export default reducer;

export {
    getMachineByIdAction,
    clearGetMachineByIdAction
}